import { IconCheck, IconClock } from '@tabler/icons-react';
import usePreSaleVisitFeedback from '../hooks/usePreSaleVisitFeedback';
import useClientFeedback from '../hooks/useClientFeedback';
import useVisitFeedback from '../hooks/useVisitFeedback';
import { ClientFeedbackService } from '../services/dashboardService';

interface Props {
  visitId: string;
  // Pre-venta usa el servicio `pre-sales`; renta/venta, `ts`.
  service?: ClientFeedbackService;
  hasProperFeedback?: boolean;
  clientFeedbackStatus?: 'pending' | 'answered';
}

// Avance de feedbacks de una visita finalizada (Proper + cliente): "2/2" si
// están completos, "1/2" o "0/2" si falta alguno. Cada dato que la lista ya
// trae se usa tal cual; el que falte se consulta por fila.
const FeedbackProgressPill = ({
  visitId,
  service = 'pre-sales',
  hasProperFeedback,
  clientFeedbackStatus,
}: Props) => {
  const isPreSale = service === 'pre-sales';
  const needsProper = hasProperFeedback === undefined;
  const needsClient = clientFeedbackStatus === undefined;
  const preSaleProper = usePreSaleVisitFeedback(
    visitId,
    needsProper && isPreSale,
    true,
  );
  const rentProper = useVisitFeedback(visitId, needsProper && !isPreSale, true);
  const proper = isPreSale ? preSaleProper : rentProper;
  const client = useClientFeedback(visitId, needsClient, false, service);

  // Sin datos fiables (cargando o error de ruta) no se muestra nada.
  if (
    (needsProper && ['loading', 'error'].includes(proper.state)) ||
    (needsClient && ['loading', 'error'].includes(client.state))
  ) {
    return null;
  }
  const properDone = needsProper
    ? proper.state === 'done'
    : hasProperFeedback === true;
  const clientDone = needsClient
    ? client.state === 'answered'
    : clientFeedbackStatus === 'answered';
  const done = Number(properDone) + Number(clientDone);
  const complete = done === 2;
  const missing = [
    !properDone && 'Proper',
    !clientDone && 'cliente',
  ].filter(Boolean);
  const title = complete
    ? 'Feedback del Proper y del cliente completos'
    : `Falta feedback de: ${missing.join(' y ')}`;

  return (
    <span
      className={`dv2-fb-progress ${complete ? 'dv2-fb-progress--done' : ''}`}
      title={title}
    >
      {complete ? <IconCheck size={12} /> : <IconClock size={12} />}
      Feedback {done}/2
    </span>
  );
};

export default FeedbackProgressPill;
